import { api } from './client';

/**
 * Series Timeline / Book Board — GET/PUT projects.arc_structure.
 * Version 3 book|gap|entrance|exit. Does not touch Series Bible or journeys.
 */
export const seriesBookBoardApi = {
  get: (projectId) => api.get(`/projects/${projectId}/book-board`),
  put: (projectId, board) => api.put(`/projects/${projectId}/book-board`, board),
};
